import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { getNotificationCounts, NotificationCounts } from '../api/notificationsApi';

export const NOTIFICATIONS_KEY = ['notifications'] as const;

export function countsQueryOptions() {
  return {
    queryKey: [...NOTIFICATIONS_KEY, 'counts'] as const,
    queryFn: getNotificationCounts,
    staleTime: 30_000,
  };
}

export function useNotificationCounts(): UseQueryResult<NotificationCounts, Error> {
  return useQuery(countsQueryOptions());
}

export function invalidateNotificationCounts(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
}
